// eslint-disable-next-line
import { Component, CustomElement } from "../../core/CustomElement";

// Components to use
import "../dialog/dialog";
import CCCDialog from "../dialog/dialog";
import "../forms/input-text";
import { CCCInputText } from "../forms/input-text";
import "../forms/select-single/index";
import { CCCSelectSingle } from "../forms/select-single/index";
import "../forms/button/index";
import { CCCField, Severity } from "../forms/field/field";

// Models
import BugDbIntegrationModel from "../../models/BugDbIntegrationModel";

@Component("ccc-bug-db-dialog", {
  template: require("./bugDbDialog.html").default,
  style: require("./bugDbDialog.scss").default,
  viewModel: require("./bugDbDialogVm"),
  observedAttributes: ["bug-db-url", "bug-db-account"],
})
// eslint-disable-next-line
export default class CCCBugDbDialog extends CustomElement {
  constructor() {
    super();
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: string,
    newValue: string
  ): void {
    switch (attr) {
      case "bug-db-url": {
        this.viewModel.bugDbUrl = newValue;
        break;
      }
      case "bug-db-account": {
        (
          this.shadowDom.querySelector("#bugAccountFld") as CCCInputText
        ).setValue(newValue);
        break;
      }
    }
  }

  public set bugDbUrl(value: string) {
    this.viewModel.bugDbUrl = value;
  }

  public set bugDbAccount(value: string) {
    (this.shadowDom.querySelector("#bugAccountFld") as CCCInputText).setValue(
      value
    );
  }

  public async initDialog(): Promise<void> {
    this.alignFields();
    await this.initBugAccountFld();
  }

  public alignFields(): void {
    const fields = [];
    fields.push(<CCCInputText>this.shadowDom.querySelector("#bugAccountFld"));
    fields.push(
      <CCCSelectSingle>this.shadowDom.querySelector("#productGroupFld")
    );
    fields.push(<CCCSelectSingle>this.shadowDom.querySelector("#productFld"));
    fields.push(<CCCSelectSingle>this.shadowDom.querySelector("#componentFld"));
    fields.push(
      <CCCSelectSingle>this.shadowDom.querySelector("#subcomponentFld")
    );
    fields.push(<CCCInputText>this.shadowDom.querySelector("#customerFld"));
    fields.forEach(($field) => {
      if ($field) {
        const $internalField = <CCCField>(
          $field.shadowDom.querySelector("ccc-field")
        );
        if ($internalField) {
          $internalField.setAttribute("label-edge", "start");
          $internalField.setAttribute("label-width", "120px");
          $internalField.setAttribute("label-align", "end");
        }
      }
    });
  }

  private async initBugAccountFld(): Promise<void> {
    const $bugAccountFld = <CCCInputText>(
      this.shadowDom.querySelector("#bugAccountFld")
    );
    // Get default bugdb account.
    const bugDbAccount =
      await BugDbIntegrationModel.getDefaultBugDbAccountCached();
    if (bugDbAccount) {
      $bugAccountFld.setValue(bugDbAccount);
    }
    // Apply subscribers.
    $bugAccountFld.applyUppercaseExtend();
    $bugAccountFld.subscribeToValueUpdated((value: string) => {
      $bugAccountFld.setAttribute("disabled", "");
      $bugAccountFld.setAttribute("internal-loading", "");
      const $bugAccountCccField: CCCField =
        $bugAccountFld.shadowDom.querySelector("ccc-field");
      $bugAccountCccField.message = null;
      BugDbIntegrationModel.getBugDbAccount(value)
        .then((bugDbAccount) => {
          if (!bugDbAccount) {
            $bugAccountCccField.message = {
              text: "The BugDB account doesn't exist.",
              severity: Severity.error,
            };
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          $bugAccountFld.removeAttribute("disabled");
          $bugAccountFld.removeAttribute("internal-loading");
        });
    });
  }

  public open(): void {
    (this.shadowDom.querySelector(".ccc-bug-db-dialog") as CCCDialog).open();
  }

  // public onSubmit(callback: () => Promise<VMCreateEpicRes>): void {
  //   (this.shadowDom.querySelector("#btnCreate") as CCCButton).addEventListener(
  //     "ccc-button-click",
  //     () => {
  //       (this.shadowDom.querySelector("#btnCreate") as CCCButton).setAttribute(
  //         "loading",
  //         ""
  //       );
  //       callback()
  //         .then((res) => {
  //           this.viewModel.saved(res.success);
  //           if (res.success) {
  //             // this.viewModel.jiraId(res.ticketId);
  //             this.viewModel.error(null);
  //           } else {
  //             this.viewModel.error(res.msg);
  //           }
  //         })
  //         .catch((error) => {
  //           console.error(error);
  //           this.viewModel.error(
  //             "Server didn't respond. Please contact an administrator."
  //           );
  //         })
  //         .finally(() => {
  //           (
  //             this.shadowDom.querySelector("#btnCreate") as CCCButton
  //           ).setAttribute("loading", "false");
  //         });
  //     }
  //   );
  // }
}
